/**
 * STUB — always reports the account as verified so the foundation flow is
 * walkable end-to-end.
 *
 * TODO(SELF-135): decide and wire the real driving signal here (single swap
 * point — callers stay untouched). The candidates, per the ticket:
 * `account.verification_state === VerificationState.Approved` /
 * `verification_review_state` (anti-abuse review — readable on the account
 * today via `useAuth()`, `@/services/auth/types`) vs. signup email
 * confirmation. Unverified users are bounced to `/onboarding/verification`
 * and never reach the stepper.
 */
export function useIsAccountVerified(): boolean {
  return true;
}
